import React from 'react';
import styled from 'styled-components';

import { createCollecticon } from '../collecticon-creator';

export const CollecticonXmark = styled(
  createCollecticon((props) => (
    <svg {...props}>
      <title>{props.title || 'xmark icon'}</title>
      <polygon points='14.707,2.707 13.293,1.293 8,6.586 2.707,1.293 1.293,2.707 6.586,8 1.293,13.293 2.707,14.707 8,9.414 13.293,14.707 14.707,13.293 9.414,8' />
    </svg>
  ))
)`
  /* icons must be styled-components */
`;
